import React from 'react';
import Hero from '../components/Hero';
import Products from '../components/Products';
import OurExpertise from '../components/OurWorks';
import Clients from '../components/Clients';
// import Testimonials from '../components/Testimonials';
import Blog from '../components/Blog';
import Contact from '../components/Contact';
import CTA from '../components/CTA';
import Services from '../components/Services';

const Home = () => {
    return (
        <>
            <Hero />
            <Clients/>
            <OurExpertise />
            <Products />
            <Services />
            {/* <Testimonials /> */}
            <Blog />
            <CTA />
            <Contact />
        </>
    );
};

export default Home;
